<template>
	<div id="page-mail-sent-failed-list" class="vx-card p-6">
		<!--      Search area-->
		<vx-card ref="filterCard" title="" class="mail-sent-failed-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
			<div class="vx-row">
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">開始日</label>
					<flat-pickr
						id="start_date"
						class="w-full flatpickr-style"
						v-model="searchParams.startDateFilter"
						placeholder="..."
						:config="configDate"
					>
					</flat-pickr>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">状態</label>
					<v-select class="w-full" id="status_filter" v-model="searchParams.statusFilter" :options="listStatusSelect">
						<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
					</v-select>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">顧客</label>
					<vs-input
						class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
						id="subject_search"
						v-model="searchParams.customerFilter"
					>
					</vs-input>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">担当者</label>
					<v-select class="w-full" id="user_filter" v-model="searchParams.userFilter" :options="listUserSelect">
						<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
					</v-select>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">終了日</label>
					<flat-pickr
						id="start_date"
						class="w-full flatpickr-style"
						v-model="searchParams.endDateFilter"
						placeholder="..."
						:config="configDate"
					>
					</flat-pickr>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">評価</label>
					<v-select class="w-full" id="assessment_filter" v-model="searchParams.assessmentFilter" :options="listAssessmentSelect">
						<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
					</v-select>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">種別</label>
					<v-select class="w-full" id="kinds_filter" v-model="searchParams.kindsFilter" :options="listKindsSelect">
						<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
					</v-select>
				</div>
				<div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
					<label class="text-sm opacity-75">タイトル</label>
					<vs-input
						class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
						id="subject_search"
						v-model="searchParams.titleFilter"
					>
					</vs-input>
				</div>
				<div class="vx-col flex flex-wrap justify-end w-full mt-5">
					<vs-button icon="assignment" @click="beforeCreate" color="success">新規作成</vs-button>
					<vs-button icon="search" @click="onSearch" color="primary" class="ml-2">検索 </vs-button>
				</div>
			</div>
		</vx-card>

		<!-- AgGrid Table -->
		<ag-grid-vue
			id="myGrid"
			ref="agGridTable"
			:components="components"
			:gridOptions="gridOptions"
			class="ag-theme-material w-100 my-4 ag-grid-table database"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="listReceiveTelephoneFormated"
			rowSelection="single"
			colResizeDefault="shift"
			:animateRows="true"
			:pagination="true"
			:domLayout="domLayout"
			:paginationPageSize="paginationPageSize"
			@sort-changed="onSortChanged"
			@grid-ready="onGridReady"
			:enableRtl="$vs.rtl"
			:overlayNoRowsTemplate="noRowsTemplate"
			:suppressPaginationPanel="true"
			:detailRowAutoHeight="true"
		>
		</ag-grid-vue>

		<div style="position: relative">
			<div>
				<div class="flex items-center justify-between">
					<span class="pl-2 mr-2" style="font: 400 13.3333px Arial"
						>{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span
					>
				</div>
			</div>
			<vs-pagination
				v-if="listReceiveTelephoneFormated.length > 0"
				:total="pagination.totalPage"
				:max="7"
				v-model="pagination.currentPage"
				class="py-10 pr-10 com-pagination"
			/>
		</div>

		<vs-popup class="z-add-customer" :title="title" :active.sync="isCreate" fullscreen>
			<div id="form-create-rt" class="h-screen text-black">
				<div class="vx-card p-2 grid grid-cols-3 gap-x-10 gap-y-1 w-full">
					<div class="grid grid-cols-3-9 mx-2 bg-input-desk rounded-l justify-center items-center w-full">
						<label class="text-sm pl-2 opacity-75">方法 <span class="text-danger">*</span></label>
						<vs-input
							class="mr-0 sm:w-auto rounded-none w-full bg-white sm:order-normal order-3 sm:mt-0 mt-4"
							id="subject_search"
							value="電話"
							disabled
						></vs-input>
					</div>
					<div class="grid grid-cols-3-9 bg-input-desk rounded-l mx-2 justify-center items-center w-full">
						<label class="text-sm pl-2 opacity-75">担当者 <span class="text-danger">*</span></label>
						<v-select class="w-full bg-white" id="user_filter" v-model="receiveTelephone.mst_user_id" :options="listUserSelect">
							<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
						</v-select>
					</div>
					<div class="grid grid-cols-3-9 bg-input-desk rounded-l mx-2 justify-center items-center w-full">
						<label class="text-sm pl-2 opacity-75">種別 <span class="text-danger">*</span></label>
						<v-select class="w-full bg-white" id="kinds_filter" v-model="receiveTelephone.mst_kinds_id" :options="listKindsSelect">
							<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
						</v-select>
					</div>
					<div class="grid grid-cols-3-9 bg-input-desk rounded-l mx-2 justify-center items-center w-full">
						<label class="text-sm pl-2 opacity-75">状態 <span class="text-danger">*</span></label>
						<v-select class="w-full bg-white" id="status_filter" v-model="receiveTelephone.mst_status_id" :options="listStatusSelect">
							<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
						</v-select>
					</div>
					<div class="grid grid-cols-3-9 bg-input-desk rounded-l mx-2 justify-center items-center w-full">
						<label class="text-sm pl-2 opacity-75">評価 <span class="text-danger">*</span></label>
						<v-select
							class="w-full bg-white"
							id="assessment_filter"
							v-model="receiveTelephone.assessment"
							:options="listAssessmentSelect"
						>
							<span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
						</v-select>
					</div>
					<div class="grid grid-cols-3-9 bg-input-desk rounded-l mx-2 justify-center items-center w-full">
						<label class="text-sm pl-2 opacity-75">次回予定日 <span class="text-danger">*</span></label>
						<flat-pickr
							id="start_date"
							class="w-full flatpickr-style"
							v-model="receiveTelephone.date"
							placeholder="..."
							:config="configDate"
						>
						</flat-pickr>
					</div>
				</div>
				<div class="vx-card header-search my-2 p-2 flex items-center justify-between">
					<div>
						<label v-show="!minisizeFlg">お客様情報:</label>
						<vs-button class="ml-6" color="success" @click="isSearchCustomer = true" v-show="!minisizeFlg">検索</vs-button>
            <label style="font-size: 1.3rem" v-if="minisizeFlg">{{customer.id ? `名前：${customer.last_name} ${customer.first_name}` : '名前：入力もしくは登録されていません'}}</label>
          </div>
          <div class="d-flex justify-end">
            <vs-button @click="onCreateReceiveTelephone" class="mr-3" :disabled="!validForm && submited">すべて保存</vs-button>
            <vs-button style="min-height: 43px" color="#757575" class="float-right" @click="minisizeFlg = !minisizeFlg">{{minisizeFlg ? '開く' : '最小化'}}</vs-button>
          </div>
        </div>
				<customer-form v-show="!minisizeFlg"
					v-model="customer"
					@changeValidCustomerInfo="changeValidCustomerInfo"
					:validCustomerInfo="validCustomerInfo"
					:submited.sync="submited"
					@clearCustomer="customer = {}"
				></customer-form>
				<div class="vx-card p-2 bg-white">
					<!-- <vs-row class="flex-wrap justify-start items-center row-card-file">
						<vs-col vs-w="1.5" class="card-title">
							<span class="pl-2">添付ファイル</span>
						</vs-col>
						<vs-col vs-w="1.75" class="flex flex-wrap items-center justify-start input-tag-file">
							<div class="pl-2">
								<input type="file" multiple ref="files" style="display: none" />
								<vs-button color="darkgray" @click="$refs.files.click()">ファイル選択</vs-button>
							</div>
						</vs-col>
						<vs-col vs-w="8.75">
							<div style="display: inline-block" v-for="(file, index) in Object.values(files)" :key="index">
								<vs-chip class="mt-1 mr-1" color="dark" transparent>{{
									file.file_name.split('/').reverse()[0] | convertFileNameSend
								}}</vs-chip>
							</div>
						</vs-col>
					</vs-row> -->

					<!-- body, subject -->
					<div class="pt-10">
						<div class="flex-wrap items-center justify-start card-title">
							<span class="pl-2">件名 <span class="text-danger">*</span></span>
						</div>
						<div>
							<vs-textarea v-model="receiveTelephone.title"></vs-textarea>
						</div>
					</div>
					<div class="pt-10 card-subject">
						<div class="flex-wrap items-center justify-start card-title">
							<span class="pl-2">本文</span>
						</div>
						<div>
							<vs-textarea v-model="receiveTelephone.content" height="220px"></vs-textarea>
						</div>
					</div>
					<div class="pt-10 card-subject">
						<div class="flex-wrap items-center justify-start card-title">
							<span class="pl-2">メモ</span>
						</div>
						<div>
							<vs-textarea v-model="receiveTelephone.memo" height="220px"></vs-textarea>
						</div>
					</div>
				</div>
			</div>
		</vs-popup>

		<vs-popup class="z-search-customer" title="検索条件" :active.sync="isSearchCustomer">
			<search-customer
				@afterSearch="isSelectCustomer = true"
				:pageCustomer="pageCustomer"
				@changePage="changePageListCustomer"
			></search-customer>
		</vs-popup>
		<vs-popup class="z-list-customer" title="検索結果" :active.sync="isSelectCustomer" fullscreen>
			<list-customer @selectCustomer="selectCustomer" :pageCustomer="pageCustomer" @changePage="changePageListCustomer"></list-customer>
		</vs-popup>
		<vs-popup id="dialogDelete" title="電話削除" :active.sync="activeDelete" button-close-hidden>
			<div>
				<span> 選択した電話を削除しますか？ </span>
			</div>
			<div class="flex justify-end mt-4">
				<vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
				<vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
			</div>
		</vs-popup>
	</div>
</template>
<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import EventBus from '@/EventBus'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import CustomerForm from './CustomerInfo.vue'
import ListCustomer from './ListCustomer.vue'
import SearchCustomer from './SearchCustomerModal.vue'
import { mapActions, mapGetters } from 'vuex'
import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'

const TYPE_TELEPHONE = 1

export default {
	components: {
		AgGridVue,
		vSelect,
		flatPickr,
		CustomerForm,
		SearchCustomer,
		ListCustomer,
		CellRendererActions
	},
	data() {
		return {
			listReceiveTelephone: [],
			searchParams: {
				statusFilter: { label: '...', value: '' },
				userFilter: { label: '...', value: '' },
				customerFilter: '',
				kindsFilter: { label: '...', value: '' },
				assessmentFilter: { label: '...', value: '' },
				subjectFilter: ''
			},
			customer: {
				id: null,
				last_name: '',
				first_name: '',
				last_name_kana: '',
				first_name_kana: '',
				email1: '',
				email2: '',
				phone_number1: '',
				phone_number2: '',
				customer_type_flg: 0,
				company_name: '',
				company_name_kana: '',
				gender: 0,
				industry_name: '',
				department_name: '',
				postal_name: '',
				prefecture_name: '',
				address: '',
				fax_number: '',
				mail_domain: '',
				retailer_name: '',
				remarks: ''
			},
			validCustomerInfo: false,
			receiveTelephone: {
				date: new Date()
			},
			listStatusSelect: [],
			listUserSelect: [],
			listKindsSelect: [],
			listAssessmentSelect: [
				{ label: '...', value: '' },
				{ label: '見込あり', value: 1 },
				{ label: '将来見込あり', value: 2 },
				{ label: '保留', value: 3 },
				{ label: '見込なし', value: 4 }
			],
			title: '電話作成',
			isCreate: false,
			activeDelete: false,
			recordSelected: null,
			isSearchCustomer: false,
			isSelectCustomer: false,
			listCustomerSelect: [],
			submited: false,
			configDate: {
				dateFormat: 'Y-m-d, H:i',
				enableTime: true,
				time_24hr: true,
				locale: Japanese,
				wrap: true,
				defaultHour: 0,
				maxDate: new Date()
			},
			files: [],
			startRow: 0,
			endRow: 0,
			pageCustomer: 1,
			pagination: {
				totalPage: 0,
				currentPage: 1,
				limit: 10,
				totalItem: 0,
				from: 1,
				to: 10
			},
			orderBy: 'date',
			orderDir: 'desc',

			// AgGrid
			noRowsTemplate: '<span>データがありません</span>',
			domLayout: 'autoHeight',
			gridApi: null,
			columnApi: null,
			gridOptions: {
				onGridSizeChanged: () => {
					this.gridApi.sizeColumnsToFit()
				}
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
				sortingOrder: ['asc', 'desc']
			},
			columnDefs: [
				{
					headerName: '次回予定日',
					field: 'date',
					width: 120,
					unSortIcon: true,
					sort: 'desc',
					suppressMovable: true
				},
				{
					headerName: '担当者',
					field: 'user_name',
					width: 100,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '顧客',
					field: 'customerName',
					width: 100,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '種別',
					field: 'kinds_name',
					width: 100,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '状態',
					field: 'status_name',
					width: 100,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '評価',
					field: 'assessment_name',
					width: 100,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '件名',
					field: 'title',
					width: 150,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '',
					field: 'transactions',
					width: 100,
					cellRendererFramework: 'CellRendererActions',
					unSortIcon: false,
					suppressMovable: true
				}
			],
			// Cell Renderer Components
			components: {
				CellRendererActions
			},

      minisizeFlg: false,
		}
	},
	watch: {
		async $route() {
			/* start loading with many requests */
			this.$store.dispatch('updateLoads', true)
			this.clearSearchFilter()
			let telephoneId = this.$route.params.telephoneId
			if (telephoneId) {
			} else if (this.telephoneFolders && this.telephoneFolders.length > 0) {
				telephoneId = this.telephoneFolders[0].receive_user_name
			}
			if (telephoneId) {
				// this.setDefaultSearchOption()
				this.orderBy = 'date'
				this.orderDir = 'desc'
				this.gridApi.setSortModel({ colId: 'date', sort: 'desc' })
				await this.onSearch()
			}
			/* stop loads */
			this.$store.dispatch('updateLoads', false)
		},
		'pagination.currentPage': {
			deep: true,
			immediate: true,
			handler: function (val) {
				if (!this.isCreate) this.paginationPage(val)
			}
		},
		activePopUp() {
			if (!this.activePopUp) {
				this.gridOptions.api.deselectAll()
			}
		}
	},
	computed: {
		...mapGetters({
			telephoneFolders: 'telephoneServer/listTelephoneFolder',
			searchFilter: 'mailSentFailed/getSearchFilter'
		}),
		paginationPageSize() {
			if (this.gridApi) return this.gridApi.paginationGetPageSize()
			else return 10
		},
		totalPages() {
			if (this.gridApi) return this.gridApi.paginationGetTotalPages()
			else return 0
		},
		totalRow() {
			return parseInt(this.pagination.totalItem)
		},
		listReceiveTelephoneFormated() {
			return this.listReceiveTelephone.map((rt) => {
				const status = this.listStatusSelect.find((status) => status.value == rt.mst_status_id) || {}
				const user = this.listUserSelect.find((user) => user.value == rt.mst_user_id) || {}
				const kinds = this.listKindsSelect.find((kinds) => kinds.value == rt.mst_kinds_id) || {}
				const assessment = this.listAssessmentSelect.find((assessment) => assessment.value == rt.assessment) || {}
				const date = rt.date.substring(0, 16)

				return {
					...rt,
					status_name: status.label || '',
					kinds_name: kinds.label || '',
					assessment_name: assessment.label || '',
					user_name: user.label || '',
					date
				}
			})
		},
		validForm() {
			return (
				this.validCustomerInfo &&
				this.receiveTelephone.mst_status_id &&
				this.receiveTelephone.mst_status_id.value &&
				this.receiveTelephone.mst_user_id &&
				this.receiveTelephone.mst_user_id.value &&
				this.receiveTelephone.mst_kinds_id &&
				this.receiveTelephone.mst_kinds_id.value &&
				this.receiveTelephone.assessment &&
				this.receiveTelephone.assessment.value &&
				this.receiveTelephone.date &&
				this.receiveTelephone.title
			)
		}
	},
	methods: {
		...mapActions({
			getListKinds: 'kinds/getListKinds',
			getListStatus: 'status/getListStatus',
			getListUser: 'telephoneServer/getListUserForTelephone',
			getReceiveTelephones: 'receiveTelephone/getReceiveTelephones',
			getReceiveTelephone: 'receiveTelephone/getReceiveTelephone',
			deleteReceiveTelephone: 'receiveTelephone/deleteReceiveTelephone',
			createOrUpdateReceiveTelephone: 'receiveTelephone/createOrUpdateReceiveTelephone',
			getListCustomer: 'customer/getCustomers'
		}),
		beforeCreate() {
			const now = new Date()
			const date = [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('-') + ', ' + [now.getHours(), now.getMinutes()].join(':')
			this.customer = {}
			this.receiveTelephone = {}
			this.receiveTelephone.date = date
			this.isCreate = true
			this.recordSelected = null
			this.title = '電話作成'
		},
		async paginationPage(value) {
			if (!this.isCreate) {
				this.pagination.currentPage = value
				let telephoneBox = this.$route.params.telephoneId
				if (telephoneBox) {
				} else if (this.telephoneFolders && this.telephoneFolders.length > 0) {
					telephoneBox = this.telephoneFolders[0].id
				}
				await this.onSearch()
			}
		},
		onSortChanged(event) {
			let columns = event.columnApi.getAllColumns()
			let root = this
			columns.forEach(function (column) {
				if (column.getSort()) {
					root.orderDir = column.getSort()
					root.orderBy = column.getColId()
					root.onSearch(false)
				}
			})
		},
		updateSortParams(orderBy, orderDir) {
			this.orderBy = orderBy
			this.orderDir = orderDir
		},
		async onSearch() {
			const { userFilter, statusFilter, kindsFilter, assessmentFilter, titleFilter, startDateFilter, endDateFilter } = this.searchParams
			let page = this.pagination.currentPage
			// if (resetPaging === true) page = 1
			// if (this.isCreate) page = this.searchFilter && this.searchFilter.telephoneBox === telephoneBox ? this.searchFilter.queries.page : 1
			const params = {
				telephoneId: this.$route.params.telephoneId,
				userId: userFilter.value,
				statusId: statusFilter.value,
				kindsId: kindsFilter.value,
				assessment: assessmentFilter.value,
				title: titleFilter,
				startDate: startDateFilter ? new Date(startDateFilter) : null,
				endDate: endDateFilter ? new Date(endDateFilter) : null,
				page: page,
				limit: this.pagination.limit,
				orderBy: this.orderBy,
				orderDir: this.orderDir
			}

			const { data: listReceiveTelephone, ...data } = await this.getReceiveTelephones(params)
			this.listReceiveTelephone = listReceiveTelephone

			this.pagination.totalItem = data.total
			this.pagination.totalPage = data.last_page
			this.pagination.currentPage = data.current_page
			this.pagination.limit = data.per_page
			this.pagination.from = data.from
			this.pagination.to = data.to
		},
		clearSearchOption() {
			this.mail_type_search = ''
			this.clearSearchCommon()
		},
		setDefaultSearchOption() {
			this.clearSearchCommon()
		},
		clearSearchCommon() {
			this.sent_date_search = ''
			this.receive_mail_id_search = ''
			this.inquiry_id_search = ''
			this.mst_user_search = ''

			this.inquiry_type_search = {
				value: '',
				label: '...'
			}
			this.state_flg_search = {
				value: '',
				label: '...'
			}
			this.type_search = {
				value: '',
				label: '...'
			}
			this.subject_search = ''
			this.body_search = ''
			//CheckMultiple v-Select
			this.checkIsMultiple = {
				state_flg: false,
				mst_user: false,
				type: false
			}
		},
		async getListKindsSelect() {
			const response = await this.getListKinds(TYPE_TELEPHONE)
			const defaultOption = { label: '...', value: '' }
			this.listKindsSelect = [...[], defaultOption]
			if (response) {
				const options = response.map(({ id, kinds_name }) => ({
					value: id,
					label: kinds_name
				}))
				this.listKindsSelect = [...this.listKindsSelect, ...options]
			}
		},
		async getListStatusSelect() {
			const data = await this.getListStatus(TYPE_TELEPHONE)
			const defaultOption = { label: '...', value: '' }
			this.listStatusSelect = [...[], defaultOption]
			if (data) {
				const options = data.map(({ id, name }) => ({
					value: id,
					label: name
				}))
				this.listStatusSelect = [...this.listStatusSelect, ...options]
			}
		},
		async getListUserSelect() {
			const response = await this.getListUser(TYPE_TELEPHONE)
			const defaultOption = { label: '...', value: '' }
			this.listUserSelect = [...[], defaultOption]
			if (response) {
				const options = response.map(({ id, name }) => ({
					value: id,
					label: name
				}))
				this.listUserSelect = [...this.listUserSelect, ...options]
			}
		},
		async resetColFilters() {
			// Reset Grid Filter
			this.gridApi.setFilterModel(null)
			this.gridApi.onFilterChanged()
			this.clearSearchFilter()
			this.clearSearchOption()
			await this.onSearch(true)
			this.$refs.filterCard.removeRefreshAnimation()
		},
		onGridReady(params) {
			this.gridApi = params.api
			this.gridColumnApi = params.columnApi
		},
		onGridReadyState(params) {
			this.gridApiState = params.api
			this.columnApiState = params.columnApi
		},
		selectionChangedvSelect() {},
		async validateForm() {
			// Email To is required
			if (this.listMailTo.length == 0 && this.mailTo == '') {
				this.messageError = 'Toは必須です。'
				return false
			}

			// validateEmail in listMail
			if (this.listMailTo.length > 0) {
				let to = this.listMailTo.find((to) => this.validateEmail(to) == false)
				if (to) {
					this.messageError = 'メールアドレス形式が正しくありません。'
					return false
				}
			}
			if (this.listMailCC.length > 0) {
				let cc = this.listMailCC.find((cc) => this.validateEmail(cc) == false)
				if (cc) {
					this.messageError = 'メールアドレス形式が正しくありません。'
					return false
				}
			}
			if (this.listMailBCC.length > 0) {
				let bcc = this.listMailBCC.find((bcc) => this.validateEmail(bcc) == false)
				if (bcc) {
					this.messageError = 'メールアドレス形式が正しくありません。'
					return false
				}
			}

			// validateEmail on input: if not press 'enter' to add listMail
			if (this.mailTo && !this.validateEmail(this.mailTo)) {
				this.messageError = 'メールアドレス形式が正しくありません。'
				return false
			}
			if (this.mailCC && !this.validateEmail(this.mailCC)) {
				this.messageError = 'メールアドレス形式が正しくありません。'
				return false
			}
			if (this.mailBCC && !this.validateEmail(this.mailBCC)) {
				this.messageError = 'メールアドレス形式が正しくありません。'
				return false
			}
			if (!this.inquiryType || (this.inquiryType && this.inquiryType.label == '...')) {
				this.messageError = '方法をご選択ください。'
				return false
			}
			if (!this.type || (this.type && this.type.value == '')) {
				this.messageError = '種別をご選択ください。'
				return false
			}
			if (this.mailSubject.length > 512) {
				this.messageError = '件名は512文字以下で指定ください。'
				return false
			}

			this.messageError = ''
			return true
		},
		selectCustomer(customer) {
			this.customer = customer
			this.isSearchCustomer = false
			this.isSelectCustomer = false
		},
		clearSearchFilter() {
			this.searchParams = {
				statusFilter: { label: '...', value: '' },
				userFilter: { label: '...', value: '' },
				customerFilter: '',
				kindsFilter: { label: '...', value: '' },
				assessmentFilter: { label: '...', value: '' },
				subjectFilter: ''
			}
		},
		async onCreateReceiveTelephone() {
			this.submited = true
			if (this.validForm) {
				const timeZone = -new Date().getTimezoneOffset / 60

				const date = new Date(this.receiveTelephone.date.split(', ').join('T') + ':00Z')

				await this.createOrUpdateReceiveTelephone({
					receiveTelephone: {
						id: this.recordSelected,
						mst_user_id: this.receiveTelephone.mst_user_id.value,
						mst_kinds_id: this.receiveTelephone.mst_kinds_id.value,
						mst_status_id: this.receiveTelephone.mst_status_id.value,
						assessment: this.receiveTelephone.assessment.value,
						mst_telephone_id: this.$route.params.telephoneId,
						content: this.receiveTelephone.content,
						title: this.receiveTelephone.title,
						date: date,
						memo: this.receiveTelephone.memo
					},
					customers: this.customer
				})
				await this.onSearch()
				this.clearEvent()
			} else {
				this.alertNotify({ color: 'danger', text: '必須項目です。' })
			}
		},
		alertNotify({ color, text }) {
			this.$vs.notify({
				time: 3000,
				position: 'bottom-right',
				title: '',
				text,
				color
			})
		},
		clearEvent() {
			this.$nextTick(() => {
				this.clearSearchFilter()
				this.isCreate = false
				this.isSearchCustomer = false
				this.isSelectCustomer = false
				this.recordSelected = null
				this.activeDelete = false
				this.submited = false
			})
		},
		async editListener(id) {
			this.recordSelected = id
			const { customer, receive_telephone } = await this.getReceiveTelephone(id)
			this.customer = customer
			const mst_user_id = this.listUserSelect.find(({ value }) => value == receive_telephone.mst_user_id)
			const mst_status_id = this.listStatusSelect.find(({ value }) => value == receive_telephone.mst_status_id)
			const mst_kinds_id = this.listKindsSelect.find(({ value }) => value == receive_telephone.mst_kinds_id)
			const assessment = this.listAssessmentSelect.find(({ value }) => value == receive_telephone.assessment)
			this.receiveTelephone = {
				...receive_telephone,
				mst_user_id,
				mst_status_id,
				mst_kinds_id,
				assessment
			}
			this.title = '電話更新'
			this.isCreate = true
		},
		deleteListener(id) {
			this.recordSelected = id
			this.activeDelete = true
		},
		async confirmDelete() {
			await this.deleteReceiveTelephone(this.recordSelected)
			this.clearEvent()
			await this.onSearch()
		},
		changePageListCustomer(page) {
			this.pageCustomer = page
		},
		changeValidCustomerInfo(value) {
			this.validCustomerInfo = value
		}
	},
	mounted() {
		// addEventListener Reload => clear
		window.addEventListener('beforeunload', this.resetColFilters)
		EventBus.$on('editRecord', this.editListener)
		EventBus.$on('deleteRecord', this.deleteListener)
		const root = this
		for (let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++) {
			document.getElementsByClassName('con-chips--input')[index].addEventListener('input', function () {
				let valueInput = document.getElementsByClassName('con-chips--input')[index].value
				if (valueInput.length > 0) {
					valueInput = valueInput.trimStart()
					// valueInput = valueInput.replaceAll('\t','')
					document.getElementsByClassName('con-chips--input')[index].value = valueInput
				}
				if (index == 0) {
					root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
				}
				if (index == 1) {
					root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
				}
				if (index == 2) {
					root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
				}
			})
		}
		for (let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++) {
			document.getElementsByClassName('con-chips--input')[index].addEventListener('blur', function () {
				let valueInput = document.getElementsByClassName('con-chips--input')[index].value
				if (valueInput.length > 0) {
					valueInput = valueInput.trim()
					// valueInput = valueInput.replaceAll('\t','')
					document.getElementsByClassName('con-chips--input')[index].value = valueInput
				}
				if (index == 0) {
					root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
				}
				if (index == 1) {
					root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
				}
				if (index == 2) {
					root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
				}
			})
		}
	},
	async created() {
		/* start loading with many requests */
		this.$store.dispatch('updateLoads', true)

		await this.getListStatusSelect()
		await this.getListUserSelect()
		await this.getListKindsSelect()
		await this.onSearch()

		/* stop loads */
		this.$store.dispatch('updateLoads', false)
	},
	updated() {
		this.$nextTick(() => {
			if (!this.$store.state.loading && this.listReceiveTelephoneFormated.length > 0) {
				this.startRow = this.pagination.currentPage * this.pagination.limit - this.pagination.limit + 1
				if (this.listReceiveTelephoneFormated.length == this.pagination.limit)
					this.endRow = this.pagination.currentPage * this.pagination.limit
				else
					this.endRow =
						this.pagination.limit * this.pagination.currentPage + this.listReceiveTelephoneFormated.length - this.pagination.limit
			} else if (this.listReceiveTelephoneFormated.length == 0) {
				this.pagination.totalItem = 0
				this.startRow = 0
				this.endRow = 0
			}
		})
	},
	beforeDestroy() {
		EventBus.$off('editRecord', this.editListener)
		EventBus.$off('deleteRecord', this.deleteListener)
		window.removeEventListener('beforeunload', this.resetColFilters, {
			passive: true
		})
	},
	destroyed() {
		// hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
		document.getElementById('dialogDelete').style.display = 'none'
		document.getElementById('dialogUpdate').style.display = 'none'
	}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/components/view/mailSentFailed.scss';
#form-create-rt {
	::v-deep .vs-con-input > .vs-input--input {
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
	}
	::v-deep .v-select > .vs__dropdown-toggle {
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
	}
	::v-deep .flatpickr-input {
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
	}
	.card-title {
		min-height: $height-input;
		height: 100%;
		background-color: #dce6f2;
		display: flex;
		align-items: center;
	}
}
.con-vs-popup {
	&.z-search-customer {
		z-index: 60001 !important;
	}
	&.z-add-customer {
		z-index: 60000 !important;
	}
	&.z-list-customer {
		z-index: 60002 !important;
	}
}
.com-pagination ::v-deep .con-vs-pagination {
	position: absolute !important;
	left: 50%;
	transform: translateX(-50%);
}
</style>
